export default "__VITE_ASSET__BrKSI8h8__"